import { Alert, Link, Typography } from '@mui/material';
import { useState } from 'react';

export default function FederalEVIncentiveAlert({ href }: { href: string }) {
  const [showIncentiveAlert, setShowIncentiveAlert] = useState(
    !window.localStorage.getItem('closedIncentiveAlert'),
  );
  const handleClosedIncentiveAlert = () => {
    window.localStorage.setItem('closedIncentiveAlert', 'true');
    setShowIncentiveAlert(false);
  };

  if (!showIncentiveAlert) {
    return null;
  }

  return (
    <Alert
      onClose={handleClosedIncentiveAlert}
      severity="warning"
      variant="filled"
      sx={{
        width: '100%',
        borderRadius: 0,
        '.MuiAlert-icon': {
          alignItems: 'center',
        },
        '.MuiAlert-action': {
          alignItems: 'center',
        },
      }}
    >
      <Typography component={'p'}>
        The federal EV tax credit expires on September 30, 2025. Purchases and binding contracts
        must be completed by that date to qualify for the credit.
      </Typography>
      <Typography component={'p'} sx={{ mt: 1 }}>
        Many popular EV makes and models are eligible for the federal incentive. Visit{' '}
        <Link href={href}>this link</Link> to learn more.
      </Typography>
    </Alert>
  );
}
